import React, { PropTypes, Component } from 'react';
import partial from 'lodash/partial';
import classnames from 'classnames';
import Money from 'common/components/money';
import ProjectLink from 'common/containers/project_link';
import NEGOTIATION_STATUSES from 'entries/offer_statuses';

export default class PendingOffers extends Component {
  constructor(props) {
    super(props);

    this.handleActionClick = this.handleActionClick.bind(this);
  }

  handleActionClick(action, entry) {
    const { setOfferNegotiationAction, project } = this.props;
    setOfferNegotiationAction(action, entry);
  }

  componentDidMount() {
    const { show, fetch } = this.props;
    if (show) {
      fetch();
    }
  }

  render() {
    const { show, entries, project, user } = this.props;
    const isClient = user.id === project.client;

    if (!show || entries.length === 0) {
      return null;
    }

    return (
      <div className="callout warning pending-offers">
        <div className="row">
          <div className="columns small-16">
            <h4>
              { isClient?
              "You made offers on the following entries:" :
              "The client has offered to buy one of your entries:" }
            </h4>
            { entries.map(entry => {
              const { actions, actor } = NEGOTIATION_STATUSES[entry.offer_negotiation_status];
              const waiting = (
                (!isClient && actor === "client") || (isClient && actor === "creative")
              );

              return (
                <div key={entry.id} className="entry">
                  <strong><Money value={entry.offer_value}/></strong> for{' '}
                  <ProjectLink project={project} append={`entry/${entry.id}/`}>
                    entry #{entry.entry_number}
                  </ProjectLink>:{' '}

                  { waiting && <strong>Waiting for { actor } to respond.</strong> }

                  { !waiting && actions.length > 0 &&
                  <div className="actions">
                    { actions.map((action, i) => {
                      let btnClass = "btn-success-outline";
                      if (action.nextStatus.includes("accept")) {
                        btnClass = "btn-success";
                      } else if (action.nextStatus.includes("decline")) {
                        btnClass = "btn-gray-outline";
                      }

                      return (
                        <button className={classnames("btn btn-sm", btnClass)} key={i}
                            onClick={partial(this.handleActionClick, action, entry)}>
                          { action.label }
                        </button>
                      );
                    }) }
                  </div> }
                </div>
              );
            }) }
          </div>
        </div>
      </div>
    );
  }
}

PendingOffers.propTypes = {
  project: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  setOfferNegotiationAction: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  entries: PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./entries/components/pending_offers.jsx